// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__kSIje","productName":"Table_productName__it5gk"};